import { atom } from "jotai";

/**
 * Tracks whether any booking creation mutation is in progress.
 * This prevents the BookingDetails screen from flashing while mutations are running.
 */
export const isCreatingBookingAtom = atom<boolean>(false);
